import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { GraphqlService } from '../../../../common/services/graphql.service';
import { OpenLinkById } from '../../../../common/services/openlinkbyid';

@Component({
  selector: 'app-othersource-content-viewer',
  templateUrl: './othersource-content-viewer.component.html',
  styleUrls: ['./othersource-content-viewer.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class OthersourceContentViewerComponent implements OnInit {

  @Input() content: any;
  @Input() title: string = '';
  @Input() IsGlossary:boolean;
  constructor(private router: Router, private graphQLService: GraphqlService, private openlink: OpenLinkById) { }
  ngOnInit(): void {
  }

  openLinkById(event) {
    let id=event.target.id;
    if(id != "" && id.includes(".pdf")){
      event.preventDefault();
    }

    this.openlink.openLinkById(event)
  }

  onRightClick(event: any) {
    let id=event.target.id;
    if (id != "" && id.includes(".pdf")) {
      let url = '/layoutComponents/getPdf?isSitesBucket=false&fileName=' + id;
      var parentElement = event.target;
      let node = document.createElement("a");
      node.href = url;
      parentElement.parentNode.insertBefore(node, parentElement);
      node.appendChild(parentElement);
    }
    else if (id=="" &&event.srcElement.tagName.toLowerCase() == "a" && event.srcElement.className.toLowerCase() == "xref" && !event.target.className.includes("term")) {
      let ahref = event.srcElement.innerText;
      if (ahref.includes("(")) { ahref = ahref.split("(")[0]; }
      if (ahref.includes("[")) { ahref = ahref.split("[")[0]; }
      if (ahref.includes("to")) { ahref = ahref.split(" to")[0]; }
      if (ahref.includes("through")) { ahref = ahref.split(" through")[0]; }
      if(isNaN(Number(ahref.split("-")[0])) && !ahref.toLocaleLowerCase().includes(("Accounting Standards Update").toLocaleLowerCase()) && !ahref.toLocaleLowerCase().includes(("subsection").toLocaleLowerCase())){
        return false;
      }
      else if (ahref.includes("-")) {
        let otherSourceUrlParts = event.target.getAttribute('href').split("/");
        event.srcElement.setAttribute("href", "/" + otherSourceUrlParts[1] + "/" + otherSourceUrlParts[2] + "/" + ahref);
      }
      else {
        let otherSourceUrlParts = event.target.getAttribute('href').split("/");
        let otherSourceUrlLastPart = event.target.getAttribute('href').includes('#') ? event.target.getAttribute('href').split('#')[1] : otherSourceUrlParts[otherSourceUrlParts.length - 1];
        event.srcElement.setAttribute("href", "/" + otherSourceUrlParts[1] + "/" + otherSourceUrlParts[2] + "/" + otherSourceUrlLastPart);
      }
    }
    else if (id=="" && event.target.className.includes("term")) {
      event.srcElement.parentElement.removeAttribute("href");
      event.srcElement.parentElement.className = event.srcElement.parentElement.className.includes("cursor-pointer") ? event.srcElement.parentElement.className : event.srcElement.parentElement.className+" cursor-pointer";
    }
  }
}
